
import { Component, Input, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { FederationsStoreActions } from 'apps/console/src/app/root-store/federations-store';
import { AccessLevel } from 'apps/console/src/app/shared-module/enums';
import * as RoutesDefinitions from 'apps/console/src/app/routes-definitions';
import { AppStoreSelectors } from 'apps/console/src/app/root-store/app-store';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';

import { IFederationListItem } from '../../models';

@Component({
	selector: 'federations-list',
	templateUrl: './federations-list.component.html',
	imports: [AsyncPipe, TranslateModule, NgbDropdownModule, NgbTooltipModule, RouterModule],
	styles: `
		input.invisible { width: 1px; }
	`
})
export class FederationsListComponent {
	private store = inject(Store);


	@Input() hasPendingFederations: boolean;
	@Input() federations: IFederationListItem[];

	currentUserIsSupport$ = this.store.select(AppStoreSelectors.selectCurrentUserIsSupport);

	accessLevel = AccessLevel;

	redirectToFederation(federationId: number) {
		this.store.dispatch(FederationsStoreActions.RedirectTo({federationId}))
	}

	redirectToFederationNewTab(federationId: number) {
		this.store.dispatch(FederationsStoreActions.RedirectToNewTab({federationId}))
	}

	getFederationDetailPath(federationId: number) {
		return RoutesDefinitions.getFederationDetailFullPath(federationId);
	}
}
